import * as React from "react";
import { NavLink } from "react-router-dom";
import { getFirstAvailableSubMenuRoute } from "../../../../utils/navigationUtils";

const RegistrationListSection = ({
  event,
  isParentMenuAvailable,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isMenuItemAvailable,
  t,
  menuHierarchy,
}) => {
  if (!(event && event.eventsite_setting && Number(event.eventsite_setting.payment_type) === 0 && isParentMenuAvailable("registration_list"))) return null;

  const shouldHideItems = Number(event.eventsite_payment_setting && event.eventsite_payment_setting.is_item) === 0;
  const filteredMenuHierarchy = Array.isArray(menuHierarchy)
    ? menuHierarchy.map((section) => {
        if (section.alias !== "registration_list" || !shouldHideItems || !Array.isArray(section.children)) {
          return section;
        }
        return {
          ...section,
          children: section.children.filter((child) => child.alias !== "items"),
        };
      })
    : menuHierarchy;

  const firstAvailableRoute = getFirstAvailableSubMenuRoute("registration_list", filteredMenuHierarchy);
  
  return (
    <li style={{ order: getParentMenuSortOrder("registration_list"), counterSet: `section ${getParentMenuDisplayNumber("registration_list")}` }} className={`${window.location.pathname.includes("event_site/billing-module") ? "bold activeList" : ""}`}>
      <span>
        <NavLink to={firstAvailableRoute || "/event_site/billing-module/manage-orders"}>{t("BILLING_BILLING_FREE_SETUP_MENU")}</NavLink>
      </span>
      <ul>
        {event.eventsite_payment_setting && Number(event.eventsite_payment_setting.is_item) === 1 && isMenuItemAvailable("items") && (
          <li>
            <NavLink to="/event_site/billing-module/items"><span className="active">{t("BILLING_ITEMS_MENU")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("orders") && (
          <li>
            <NavLink to="/event_site/billing-module/manage-orders"><span className="active">{t("BILLING_VOUCHER_ORDERS")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("registration_form_stats") && (
          <li>
            <NavLink to="/event_site/billing-module/registration_form/statsdashboard"><span className="active">{t("BILLING_REGISTRATION_FORM_MENU")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("waiting_list_orders") && (
          <li>
            <NavLink to="/event_site/billing-module/waiting-list-orders"><span className="active">{t("BILLING_WAITING_LIST_ORDERS")}</span></NavLink>
          </li>
        )}
      </ul>
    </li>
  );
};

export default RegistrationListSection;
